export const pdfTheme = {
  colors: {
    primary: '#2e7d32',
    primaryLight: '#e8f5e9',
    success: '#4caf50',
    successLight: '#e8f5e9',
    warning: '#ff9800',
    warningLight: '#fff3e0',
    text: '#666',
    border: '#e0e0e0',
    white: '#ffffff',
  },
  fontFamily: '"Avenir LT Pro", Arial, Helvetica, sans-serif',
};
